import { createSelector } from 'reselect'
import { getGroupPosition, getMediaPosition} from 'redux/navigation/selectors'

export const getTableOfContents = state => state.tableOfContents.table || []

export const isTableOfContentsAsideEnabled = createSelector(
    getTableOfContents,
    tableOfContents => tableOfContents.length > 0
)

export const isTableOfContentsItemSelected = createSelector(
    getTableOfContents,
    getMediaPosition,
    getGroupPosition,
    (state, index) => index,
    (tableOfContents, mediaPosition, groupPosition, index) => {

        if(
            tableOfContents[index] === undefined
            || tableOfContents[index].positions === null
        ){
            return false
        }

        const positions = tableOfContents[index].positions
        if(positions.media === mediaPosition && positions.group === groupPosition)
        {
            return true
        }

        return false
    }
)

export const getTableOfContentsCurrentIndex = createSelector(
    getTableOfContents,
    getMediaPosition,
    getGroupPosition,
    (tableOfContents, mediaPosition, groupPosition) => {
        let currentIndex = 0
        tableOfContents.forEach((item, index) => {
            if(item.positions === null)
            {
                return
            }

            if(item.positions.group === groupPosition && item.positions.media === mediaPosition)
            {
                currentIndex = index
            }
        })

        return currentIndex
    }
)

export const isTableOfContentsOpened = state => state.tableOfContents.isOpened === true
